const {
  apiRequest,
} = require('../ws');
const {
  uploadDocument,
} = require('../upload');


export function apiV2KycGetStatus() {
  return apiRequest('/v2/kyc/status', {}, () => {
    return {
      // verification_state: 'pending',
      verification_state: 'rejected',
      message: 'Please contact Lunu Support.',
      status: 'completed',
      company: {
        status: 'completed',
        company: {},
      },
      profile: {
        status: 'completed',
        profile: {},
      },
      owner: {
        status: 'completed',
        list: [],
      },
      document: {
        status: 'completed',
        list: [],
      },
      bank: {
        status: 'completed',
        bank: {},
      },
    };
  });
}
export function apiV2KycCompanyProfileSubmit(params) {
  return apiRequest('/v2/kyc/company-profile/submit', params);
}
export function apiV2KycPersonalProfileSubmit(params) {
  return apiRequest('/v2/kyc/personal-profile/submit', params);
}
export function apiV2KycDocumentsSubmit(params) {
  return apiRequest('/v2/kyc/document/submit', params);
}
export function apiV2KycBankSubmit(params) {
  return apiRequest('/v2/kyc/bank/submit', params);
}

/*
// never used
export function apiV2KycOwnerGet(params) {
  return apiRequest('/v2/kyc/owner/get', params);
}
export function apiV2KycOwnerList(params) {
  return apiRequest('/v2/kyc/owner/list', params);
}
*/
export function apiV2KycOwnerCreate(params) {
  return apiRequest('/v2/kyc/owner/create', params);
}
export function apiV2KycOwnerUpdate(params) {
  return apiRequest('/v2/kyc/owner/update', params);
}
export function apiV2KycOwnerRemove(params) {
  return apiRequest('/v2/kyc/owner/remove', params);
}

/*
// never used
export function apiV2KycDocumentList(params) {
  return apiRequest('/v2/kyc/document/list', params);
}
*/
export function apiV2KycDocumentRemove(params) {
  return apiRequest('/v2/kyc/document/remove', params);
}
export function apiV2KycDocumentUpload(params) {
  return uploadDocument({
    ...params,
    uploadUrl: params.uploadUrl || '/v2/doc/upload',
  });
}
